
import React from 'react';
import MarketingNavigation from './MarketingNavigation';
import HeroSection from './HeroSection';
import { FeaturesSection } from './sections/FeaturesSection';
import { ProblemSolutionSection } from './sections/ProblemSolutionSection';
import { ROIMetricsSection } from './sections/ROIMetricsSection';
import { SocialProofSection } from './sections/SocialProofSection';
import { CTASection } from './sections/CTASection';
import MarketingFooter from './MarketingFooter';
import { MarketingAgentHierarchy } from './MarketingAgentHierarchy';

const NewBrandLandingPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <MarketingNavigation />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ProblemSolutionSection />
        
        {/* Agent Hierarchy Showcase Section */}
        <section className="py-16 bg-muted/30">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">
                Meet Your AI Recruitment Team
              </h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Experience our multi-agent orchestration system in action. Watch as specialized AI agents collaborate to transform your recruitment process.
              </p>
            </div>
            <MarketingAgentHierarchy />
          </div>
        </section>
        
        <ROIMetricsSection />
        <SocialProofSection />
        <CTASection />
      </main>
      <MarketingFooter />
    </div>
  );
};

export default NewBrandLandingPage;
